export enum BidWorkflowPhase {
	BidCreation = 11,
	BidSpecification = 13,
	BidApproval = 15,
	BidPublishing = 16,
	BidEvaluation = 17,
	BidAward = 20,
	BidAdjudication = 52,
	SupplierBidding = 53,
	ManualBidCapturing = 54,
}
